export default "__VITE_ASSET__B6M1SYvc__"